import gql from "graphql-tag";
import { AnalyticsListEntry } from "../baseTypes";
export default gql`
  query GetGraph($filter: SearchableTestFilterInput!) {
    getList(filter: $filter) {
      locationId
      invalid
      positiv
      negativ
    }
  }
`;
export interface GetAnalyticsListQuery {
  getList: Array<AnalyticsListEntry> | null;
}
